const is3DSSuccess = (data) =>
  ['success', 'already_paid'].includes(data?.status)

export default is3DSSuccess
